import { defaultLanguages, type ZudokuConfig } from 'zudoku';
import { AuthPage } from './src/AuthPage';
import { RealtimeApiPage } from './src/RealtimeApiPage';

const config: ZudokuConfig = {
  site: {
    title: 'CapWorks API',
    logo: {
      src: {
        light: '/favicon.svg',
        dark: '/favicon.svg',
      },
      alt: 'CapWorks',
      width: 34,
    },
  },
  metadata: {
    title: 'CapWorks API 文档',
    description: 'CapWorks HTTP、认证、实时协作与 OpenConnector API 的统一文档。',
    applicationName: 'CapWorks API Docs',
  },
  theme: {
    light: {
      primary: '263 100% 61%',
      primaryForeground: '0 0% 100%',
    },
    dark: {
      primary: '263 100% 72%',
      primaryForeground: '263 42% 10%',
    },
  },
  navigation: [
    {
      type: 'category',
      label: '开始使用',
      items: [
        { type: 'doc', file: 'introduction', label: '概览', path: '/' },
        {
          type: 'custom-page',
          path: '/login',
          label: '登录 / API 测试',
          element: <AuthPage />,
        },
        'authentication',
        'conventions',
      ],
    },
    {
      type: 'category',
      label: 'API Reference',
      items: [
        { type: 'link', to: '/api/capworks', label: 'CapWorks HTTP API' },
        { type: 'link', to: '/api/auth', label: 'Better Auth API' },
        {
          type: 'custom-page',
          path: '/api/realtime',
          label: '实时 API',
          element: <RealtimeApiPage />,
        },
        { type: 'link', to: '/api/openconnector', label: 'OpenConnector API' },
      ],
    },
    {
      type: 'category',
      label: '维护与部署',
      items: ['coverage', 'cloudflare'],
    },
  ],
  apis: [
    {
      type: 'file',
      input: './apis/capworks.openapi.json',
      path: '/api/capworks',
    },
    {
      type: 'file',
      input: './apis/auth.openapi.json',
      path: '/api/auth',
    },
    {
      type: 'file',
      input: './apis/openconnector.openapi.json',
      path: '/api/openconnector',
    },
  ],
  defaults: {
    apis: {
      examplesLanguage: 'shell',
      schemaDownload: { enabled: true },
    },
  },
  syntaxHighlighting: {
    languages: [...defaultLanguages, 'http'],
  },
  docs: {
    files: '/pages/**/*.mdx',
  },
};

export default config;
